import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getDetailPageIDAPI,
  getPagePermissionOptionsAPI,
  postPageIDAPI,
  putPageIDAPI,
  getJSONPageIDDetailsAPI,
} from 'features/Account/services/adminAccessPageID'
import { downloadFileBlob } from 'utils/downloadFileUrl'
import { dateFormat } from 'utils/helpers/date'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

export const SLICE_NAME = 'adminAccessAddEditPageID'

export const fetchGetDetailPageID = createAsyncThunk(
  `${SLICE_NAME}/fetchGetDetailPageID`,
  async (
    { pageId, isVendor = false }: { pageId: string; isVendor: boolean },
    { rejectWithValue },
  ) => {
    try {
      const response = await getDetailPageIDAPI(pageId, isVendor)

      return response.data.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchPostPageID = createAsyncThunk(
  `${SLICE_NAME}/fetchPostPageID`,
  async (
    action: {
      payload: Parameters<typeof postPageIDAPI>[0]
      callback?: () => void
      isVendor: boolean
    },
    { rejectWithValue },
  ) => {
    try {
      const { payload, callback, isVendor } = action
      const response = await postPageIDAPI(payload, isVendor)

      if (callback) {
        callback()
      }

      toastSuccess('Page ID berhasil dibuat')
      return response.data.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchPutPageID = createAsyncThunk(
  `${SLICE_NAME}/fetchPutPageID`,
  async (
    action: {
      pageId: string
      payload: Parameters<typeof putPageIDAPI>[0]['payload']
      callback?: () => void
      isVendor: boolean
    },
    { rejectWithValue },
  ) => {
    try {
      const { pageId, payload, callback, isVendor } = action
      const response = await putPageIDAPI({
        id: pageId,
        payload,
        isVendor,
      })

      if (callback) {
        callback()
      }

      toastSuccess('Page ID berhasil diubah')
      return response.data.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchGetPermissionOptionsPageID = createAsyncThunk(
  `${SLICE_NAME}/fetchGetPermissionOptionsPageID`,
  async ({ isVendor }: { isVendor: boolean }, { rejectWithValue }) => {
    try {
      const response = await getPagePermissionOptionsAPI(isVendor)

      return response.data.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchGetJSONPageIDDetails = createAsyncThunk(
  `${SLICE_NAME}/fetchGetJSONPageIDDetails`,
  async ({ id, isVendor }: { id: string; isVendor: boolean }, { getState, rejectWithValue }) => {
    try {
      const {
        adminAccessAddEditPageID: { detail },
      } = getState() as StoreStateType
      const response = await getJSONPageIDDetailsAPI(id, isVendor)
      const jsonString = response.data.data.page_json
      const generateFileName = () => {
        const pageName = detail?.page.name
          ?.replace(/\s+/g, '_') // Replace spaces with underscores
          .replace(/[^a-zA-Z0-9-_]/g, '') // Remove special characters
          .toLowerCase()
        return `${pageName}_${dateFormat({ date: new Date(), format: 'DD-MMM-YYYY_HH:mm:ss' })}`
      }
      downloadFileBlob({
        data: jsonString,
        fileName: generateFileName(),
        mimeType: 'application/json',
      })
      return true
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
